


















































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

// Components
import SelectField from '@/components/Form/SelectField.vue';
import TextArea from '@/components/Form/TextArea.vue';
import TextField from '@/components/Form/TextField.vue';
import StaffAuditLogModal from '@/components/Modal/StaffAuditLog.vue';
import Alert from '@/components/Global/Alert.vue';

// Services
import jQuery from 'jquery';
import axios from 'axios';

@Component({
	name: 'TabAuditLog',
	components: {
		SelectField,
		TextArea,
		TextField,
		StaffAuditLogModal,
		Alert,
	},
})
export default class TabAuditLog extends Vue {
	@Prop() private user: any;
	private auditLog: {
		log: any;
		events: any;
		sites: any;
	} = {
		log: [],
		events: {},
		sites: {},
	};
	private openCustomMessage: boolean = false;
	private customLog: any = {
		message: '',
		reason: '',
		brand: '',
	};
	private customLogError: boolean = false;
	private customLogSuccess: boolean = false;
	private paginate: string[] = ['audit'];
	private filterSite: string = '';
	private filterEvent: string = '';
	private selectedLog: {
		event_id: string;
		event_stamp: string;
		site: string;
		msg: string;
	} = {
		event_id: null,
		event_stamp: null,
		site: null,
		msg: null,
	};

	@Watch('filterSite')
	private watchFilterSite() {
		this.filter();
	}

	@Watch('filterEvent')
	private watchFilterEvent() {
		this.filter();
	}

	/**
	 * Filter the audit log results
	 */
	private filter() {
		this.auditLog.log = this.user.auditLog
			.map(log => {
				if (this.filterSite !== '' && this.filterEvent !== '') {
					if (log.site === this.filterSite && log.type === this.filterEvent) {
						return log;
					}
				} else if (this.filterEvent !== '' && log.type === this.filterEvent) {
					return log;
				} else if (this.filterSite !== '' && log.site === this.filterSite) {
					return log;
				} else if (this.filterSite === '' && this.filterEvent === '') {
					return log;
				}
			})
			.filter(log => {
				if (log !== 'undefined') {
					return log;
				}
			});
	}

	/**
	 * Setup the Audit log
	 */
	private setupAuditLog() {
		this.auditLog.log = this.user.auditLog;

		// Some ES6 MAGIC!! :D
		this.auditLog.events = Array.from(
			new Set(
				this.auditLog.log.map(log => {
					return log.type;
				}),
			),
		);

		// Some ES6 MAGIC!! :D
		this.auditLog.sites = Array.from(
			new Set(
				this.auditLog.log.map(log => {
					return log.site;
				}),
			),
		);
	}

	private changeEvent($event) {
		this.filterEvent = $event.target.value;
	}

	private changeSite($event) {
		this.filterSite = $event.target.value;
	}

	private openLog(log) {
		this.selectedLog = log;
		jQuery('#StaffAuditLog').modal('show');
	}

	private mounted() {
		this.setupAuditLog();
	}

	private async saveMessage() {
		this.customLogError = false;
		this.customLogSuccess = false;

		const sendData = {
			cmd: 'saveAuditLogMessage',
			...this.customLog,
			sub: this.user.sub,
		};

		if (this.customLog.message.length <= 0 && this.customLog.reason !== '') {
			this.customLogError = true;
			return;
		}

		try {
			const { data } = await axios({
				method: 'POST',
				url: process.env.VUE_APP_API_URI + '/staff/users',
				data: sendData,
			});

			this.customLogSuccess = true;
			this.customLog = {
				message: '',
				reason: '',
				brand: '',
			};
		} catch (e) {
			console.log(e);
			this.customLogError = true;
		}
	}
}
